module.exports = __webpack_public_path__ + "img/pos1.7d0f4cac.webp";